export const DEFAULT_HOST = "http://allegrobot.com";
export const API_VERSION = 1;
